import styled from 'styled-components';
import { COLORS } from '../../../../../../../constants/radar';

export const FormContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${COLORS.BORDER};
`;

export const FormTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${COLORS.SECONDARY};
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${COLORS.BACKGROUND};
    color: ${COLORS.PRIMARY};
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.SECONDARY};
`;

export const Input = styled.input`
  padding: 10px 12px;
  border: 1px solid ${COLORS.BORDER};
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${COLORS.PRIMARY};
    box-shadow: 0 0 0 2px ${COLORS.PRIMARY}20;
  }
`;

export const TextArea = styled.textarea`
  padding: 10px 12px;
  border: 1px solid ${COLORS.BORDER};
  border-radius: 4px;
  font-size: 14px;
  min-height: 100px;
  resize: vertical;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${COLORS.PRIMARY};
    box-shadow: 0 0 0 2px ${COLORS.PRIMARY}20;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: auto;
  padding-top: 24px;
`;

export const Button = styled.button`
  flex: 1;
  padding: 10px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const CancelButton = styled(Button)`
  background: white;
  border: 1px solid ${COLORS.BORDER};
  color: ${COLORS.SECONDARY};

  &:hover {
    background: ${COLORS.BACKGROUND};
  }
`;

export const SubmitButton = styled(Button)`
  background-color: ${COLORS.PRIMARY};
  border: none;
  color: white;

  &:hover {
    background-color: ${COLORS.SECONDARY};
  }
`; 